export enum OrderTypes {
    VEHICLE = "Pojazd",
    CONTAINER = "Kontener",
    WEIGHT = "Tonaż",
  }